import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const handleChange = (event) => {
    const newLang = event.target.value;
    i18n.changeLanguage(newLang);
  };

  return (
    <div className="flex items-center gap-3">
      <Globe size={20} className="text-text-muted" />
      <select
        value={i18n.language?.substring(0, 2) || 'de'}
        onChange={handleChange}
        className="input w-auto py-2 px-3 min-w-[120px] cursor-pointer"
      >
        <option value="de">Deutsch</option>
        <option value="en">English</option>
      </select>
    </div>
  );
};

export default LanguageSwitcher;
